import { styled } from 'linaria/react';

export const RoomParamsContainer = styled.div`
  padding: var(--space-250);
  padding-bottom: var(--space-200);
  margin-bottom: var(--space-250);
  border: solid 1px var(--control-secondary);
  border-radius: var(--rounding-l);
  cursor: pointer;
  transition: 0.3s;

  @media (--only-mobile) {
    margin-bottom: var(--space-400);
  }
`;

export const ParamsListContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: var(--space-50);
  width: 100%;

  @media (--only-mobile) {
    flex-wrap: nowrap;
  }
`;

export const ParamsListTitle = styled.div`
  display: flex;
  flex-wrap: nowrap;
`;

export const ParamsListRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
`;

export const ParamsListColumnRight = styled(ParamsListTitle)`
  margin-left: auto;
`;
